var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ProductType } from '@shared/utils/Instruments/ProductType';
import { OrderTif } from '@shared/utils/Trading/OrderTifEnum';
import { DataCache } from '../../DataCache';
import { BaseSettingsUtils } from '../../UtilsClasses/BaseGeneralSettingsUtilsWrapper';
import { MarginInfoParameters } from '../../UtilsClasses/MarginInfo/MarginInfoParameters';
import { MarginInfoWrapper } from '../../UtilsClasses/MarginInfo/MarginInfoWrapper';
import { OrderFormatter } from '../../cache/Formatters/OrderFormatter';
import { Resources } from '@shared/localizations/Resources';
import { TvInteriorIdCache } from '../Caches/TvInteriorIdCache';
import { TvOrderConvertor } from '../Convertors/TvOrderConvertor';
import { TvSymbolConvertor } from '../Convertors/TvSymbolConvertor';
import { TvAccountHelper } from '../Helpers/TvAccountHelper';
import { TvOrdersManager } from '../Managers/TvOrdersManager';
import { OperationType } from '@shared/utils/Trading/OperationType';
class _TvOrderPreview {
    previewOrder(order) {
        return __awaiter(this, void 0, void 0, function* () {
            const account = TvAccountHelper.getCurrentAccount();
            const symbol = order.symbol;
            const interiorId = TvInteriorIdCache.getInteriorId(symbol);
            const instrument = DataCache.getInstrumentByName(interiorId);
            let exchange = '';
            if (!isNullOrUndefined(instrument)) {
                exchange = TvSymbolConvertor.getMarketExchange(instrument);
            }
            else {
                console.error(`[TvOrderPreview::previewOrder]: Instrument ${symbol} not found`);
            }
            const addiditionalSections = [];
            const addiditionalInfo = {
                header: '',
                rows: [this.getExchangeRow(exchange), this.getTifRow(order.duration)]
            };
            addiditionalSections.push(addiditionalInfo);
            const orderEditBase = TvOrdersManager.createOrderEditBase(order, account);
            const warnings = yield this.getWarings(orderEditBase);
            const marginResponse = orderEditBase.getLastMarginResponse();
            const marginInfoSections = yield this.getMarginInfoSections(order, account, instrument, marginResponse);
            addiditionalSections.push(...marginInfoSections);
            const preview = {
                // confirmId
                sections: addiditionalSections
                // errors: ['test error 1', 'test error 2']
            };
            if (warnings.length > 0) {
                preview.warnings = warnings;
            }
            return preview;
        });
    }
    getExchangeRow(exchange) {
        const exchangeRow = {
            title: Resources.getResource('TvTradingPlatform.OrderConfirmation.Exchange'),
            value: exchange
        };
        return exchangeRow;
    }
    getTifRow(duration) {
        const tifId = OrderTif[duration.type];
        const date = !isNullOrUndefined(duration.datetime) ? new Date(duration.datetime) : new Date();
        const formattedValidityStr = OrderFormatter.GetFormattedValidityStr(tifId, date);
        const exchangeRow = {
            title: Resources.getResource('TvTradingPlatform.OrderConfirmation.TimeInForce'),
            value: formattedValidityStr
        };
        return exchangeRow;
    }
    getWarings(orderEditBase) {
        return __awaiter(this, void 0, void 0, function* () {
            const confirmationData = yield orderEditBase.getConfirmationData();
            if (!BaseSettingsUtils.needToShowWarning(confirmationData))
                return [];
            const localizedWarnings = confirmationData.warningArray.map((warning) => Resources.getResource(warning));
            return localizedWarnings;
        });
    }
    getMarginInfoSections(order, account, instrument, marginResponse) {
        return __awaiter(this, void 0, void 0, function* () {
            const parameters = new MarginInfoParameters();
            parameters.account = account;
            parameters.instrument = instrument;
            parameters.operation = order.side === 1 /* Side.Buy */ ? OperationType.Buy : OperationType.Sell;
            parameters.amountLots = order.qty;
            parameters.price = order.limitPrice;
            parameters.stopPrice = order.stopPrice;
            parameters.orderType = TvOrderConvertor.getRealOrderType(order.type);
            parameters.productType = ProductType.General; // TODO: support product type
            const marginInfoWrapper = new MarginInfoWrapper();
            marginInfoWrapper._parameters = parameters;
            const groups = yield marginInfoWrapper.getInfoAsync(marginResponse);
            const sections = [];
            for (const group of groups) {
                const marginInfoRows = group.items.map((item) => {
                    const row = {
                        title: item.title,
                        value: item.formattedValue
                    };
                    return row;
                });
                const section = {
                    header: group.title,
                    rows: marginInfoRows
                };
                sections.push(section);
            }
            return sections;
        });
    }
}
export const TvOrderPreview = new _TvOrderPreview();
